import React, { useMemo, useState } from 'react';
import Button from './Button/Button';
import Modal from './Modal/Modal';
import CancelCreditFunding from './CancelCreditFunding';
import alert from '../helpers/alert';
import extractErrorMessage from '../utils/extractErrorMessage';
import cancelCreditAppeal from '../api/creditPlatform/forte/cancelCreditAppeal';
import berekeManualReject from '../api/bank/berekeManualReject';
import { BANKS, BANKS_OPTIONS, DEAL_STEPS } from '../constants';
import {
  BANK_CREDIT_STATUSES,
  BANK_CREDIT_CANCELLED,
  BANK_CREDIT_REJECTED,
} from '../constants/bankCreditStatuses';

// ÐÐ°Ð½ÐºÐ¸, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ Ð½Ð° Ð±ÑÐºÐµ ÑÐµÐ°Ð»Ð¸Ð·Ð¾Ð²Ð°Ð½Ð° Ð¾ÑÐ¼ÐµÐ½Ð° Ð·Ð°ÑÐ²ÐºÐ¸
// (Ð´Ð¸ÑÐ¿ÐµÑÑÐµÑ cancelCreditAppeal: Euraz/ÐÐ¦Ð/Halyk/Forte/Sapa; Bereke â Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹ ÑÐ½Ð´Ð¿Ð¾Ð¸Ð½Ñ)
// BANKS.BEREKE Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾ Ð¾ÑÐºÐ»ÑÑÑÐ½ â Ð±Ð°Ð½Ðº Ð²ÐµÑÐ½ÑÑÑÑ Ñ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¾Ð¹ ÑÑÑÐ½Ð¾Ð³Ð¾ Ð¾ÑÐºÐ°Ð·Ð°.
// Ð§ÑÐ¾Ð±Ñ Ð²ÐµÑÐ½ÑÑÑ: Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ BANKS.BEREKE Ð¾Ð±ÑÐ°ÑÐ½Ð¾ Ð² Ð¼Ð°ÑÑÐ¸Ð² (ÑÐ½Ð´Ð¿Ð¾Ð¸Ð½Ñ/Ð¼ÐµÑÐ¾Ð´ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ).
const CANCEL_SUPPORTED = [BANKS.EURAZ, BANKS.BCK, BANKS.HALYK, BANKS.FORTE, BANKS.SAPA];

const bankMeta = (id) => BANKS_OPTIONS.find((b) => b.value === id) || {};

// ÐÑÑÑ Ð»Ð¸ Ñ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ Ð´Ð»Ñ Ð¾ÑÐ¼ÐµÐ½Ñ
const hasCancelId = (a) =>
  a?.bank?.id === BANKS.BEREKE ? a?.bankUniqueId || a?.bankOwnerId : a?.bankOwnerId;

const BankAppealsCancelBlock = ({ creditAppeals, deal, update }) => {
  const [confirmAppeal, setConfirmAppeal] = useState(null);
  const [loading, setLoading] = useState(false);

  // Ð¤Ð¸Ð½Ð°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐÐ²ÑÐ°Ð·Ð° ÑÐ¶Ðµ Ð²ÑÐ´Ð°Ð½Ð¾ â Ð½ÑÐ¶ÐµÐ½ Ð²Ð¾Ð·Ð²ÑÐ°Ñ Ð¢Ð¡ (Ð´ÑÑÐ³Ð¾Ð¹ Ð¿Ð¾ÑÐ¾Ðº)
  const isEurazFinanced = deal?.step === DEAL_STEPS.FINISH;

  const cancelableAppeals = useMemo(() => {
    return (creditAppeals || []).filter(
      (a) =>
        CANCEL_SUPPORTED.includes(a?.bank?.id) &&
        hasCancelId(a) &&
        a?.statusId !== BANK_CREDIT_CANCELLED &&
        a?.statusId !== BANK_CREDIT_REJECTED
    );
  }, [creditAppeals]);

  if (!cancelableAppeals.length) return null;

  const doCancel = async (appeal) => {
    setLoading(true);
    try {
      if (appeal?.bank?.id === BANKS.BEREKE) {
        await berekeManualReject(appeal?.bankUniqueId || appeal?.bankOwnerId);
      } else {
        await cancelCreditAppeal(appeal?.id);
      }
      alert.success('ÐÐ°ÑÐ²ÐºÐ° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð°');
      setConfirmAppeal(null);
      if (update) update();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¼ÐµÐ½Ðµ Ð·Ð°ÑÐ²ÐºÐ¸');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: 20, border: '1px solid #E0E0E0', borderRadius: 8, padding: 16 }}>
      <p style={{ fontWeight: 600, marginBottom: 12 }}>ÐÑÐ¼ÐµÐ½Ð° Ð·Ð°ÑÐ²Ð¾Ðº Ð¿Ð¾ Ð±Ð°Ð½ÐºÐ°Ð¼</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {cancelableAppeals.map((appeal) => {
          const meta = bankMeta(appeal?.bank?.id);
          const name = appeal?.bank?.name || meta.label || 'ÐÐ°Ð½Ðº';
          const isEuraz = appeal?.bank?.id === BANKS.EURAZ;
          return (
            <div
              key={appeal?.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                flexWrap: 'wrap',
                paddingBottom: 8,
                borderBottom: '1px solid #F0F0F0',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 200 }}>
                {meta.image ? (
                  <img
                    src={meta.image}
                    alt={name}
                    style={{ height: 24, width: 'auto', objectFit: 'contain' }}
                  />
                ) : null}
                <span style={{ fontWeight: 500 }}>{name}</span>
                <span style={{ color: '#888', fontSize: 13 }}>
                  {BANK_CREDIT_STATUSES[appeal?.statusId] || ''}
                </span>
              </div>

              {isEuraz && isEurazFinanced ? (
                <CancelCreditFunding
                  dealId={deal?.id}
                  bankOwnerId={appeal?.bankOwnerId}
                  chunkId={deal?.chunkId}
                  buttonText="ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¸ ÑÐ¸Ð½Ð°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ"
                />
              ) : (
                <Button fill onClick={() => setConfirmAppeal(appeal)}>
                  ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ
                </Button>
              )}
            </div>
          );
        })}
      </div>

      <Modal
        isOpen={!!confirmAppeal}
        onRequestClose={() => (loading ? null : setConfirmAppeal(null))}
        contentStyle={{ maxWidth: 420, bottom: 'auto', height: 'auto', borderRadius: 10 }}
        title="ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð¾ÑÐ¼ÐµÐ½Ñ Ð·Ð°ÑÐ²ÐºÐ¸"
      >
        <p style={{ marginBottom: 24, fontSize: 15 }}>
          ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐµ{' '}
          <b>{confirmAppeal?.bank?.name || bankMeta(confirmAppeal?.bank?.id).label}</b>?
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <Button
            disabled={loading}
            onClick={() => setConfirmAppeal(null)}
            style={{ border: '1px solid #B45436', background: '#fff', color: '#B45436', padding: '12px 28px' }}
          >
            ÐÐµÑ
          </Button>
          <Button fill disabled={loading} onClick={() => doCancel(confirmAppeal)}>
            {loading ? 'ÐÑÐ¼ÐµÐ½Ð°â¦' : 'ÐÐ°, Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÑ'}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default BankAppealsCancelBlock;
